import { FC } from "react";
import { CopyButton } from "./CopyButton";
import { Stack, IconButton } from "@mui/material";
import OpenInNewRounded from "@mui/icons-material/OpenInNewRounded";
import { Link } from "react-router-dom";
export type LinksContainerProps = {
  url: string;
};
export const LinksContainer: FC<LinksContainerProps> = ({
  url
}) => {
  if (!url) return null; //TODO visual indication of missing meta data
  return <Stack direction="row" sx={{
    alignItems: "center",
    gap: 1,
    visibility: "hidden",
    "&:hover": {
      visibility: "visible"
    }
  }} data-sentry-element="Stack" data-sentry-component="LinksContainer" data-sentry-source-file="LinksContainer.tsx">
      <CopyButton url={url} data-sentry-element="CopyButton" data-sentry-source-file="LinksContainer.tsx" />
      <IconButton component={Link} to={url} data-sentry-element="IconButton" data-sentry-source-file="LinksContainer.tsx">
        <OpenInNewRounded fontSize="small" data-sentry-element="OpenInNewRounded" data-sentry-source-file="LinksContainer.tsx" />
      </IconButton>
    </Stack>;
};